/* eslint-disable linebreak-style */

/*
 * @FileName: Do not edit
 * @Date: 2022-02-11 10:07:54
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 16:06:15
 * @FilePath: \mobile-portal\src\lang\inner\en\common.js
 */
export default {
  common: {
    noData: 'No data',
    Know: 'Confirm',
    noMore: 'No more',
    allCheck: 'Check all',
    success: 'Operation successful',
    searchMsg: 'Process ID / Process name /Applicant',
    SelectPersonnel: 'Select Personnel',
    empty: 'Reset',
    confirm: 'Confirm',
    selectClassification: 'Please select process classification',
    follow: 'Follow',
    focus: 'Followed',
    participants: 'Transfer records',
    reply: 'Reply',
    replied: 'Replied',
    invalid: 'Invalid',
    failed: 'Submit failed',
    Home: 'Home',
    Process: 'Start Process',
    Workbench: 'Workbench',
    enterMsg: "Please enter person's name",
    NoResult: 'No data',
    NoDataSelected: 'No data selected',
    loading: 'Loading',
    cancel: 'Cancel',
    recall: 'recall',
    Notice: 'Notice',
    open: 'Unfold',
    PutAway: 'pack up',
    year: 'year',
    tips:'Tips',
    approvalTips:'Please confirm whether to proceed with the 【{0}】 operation?',
  },
  message: {
    msg: 'Please enter the process name',
    msg0: 'Please enter process classification',
    msg1: 'Please select actvie processes',
    msg2: 'Remove from favorites successfully!',
    msg3: 'Already added!',
    msg4: 'Add to Favorites successfully!',
    msg5: 'No data',
    msg6: 'Select {0}',
    msg7: 'Select {0}',
  },
  home: {
    todo: 'My To Do',
    copy: 'My WatchList',
    communicationo: 'My Communications',
    launch: 'My Requests',
    involved: 'Involved Process',
    follow: 'My attention',
    process: 'My Processes',
    participate: 'Processed',
    Submit: 'My Requests',
  },
  workbench: {
    ComTime: 'Communication Time',
    LaunchTime: 'Start Time',
    EndTime: 'Finish Time',
    Sponsor: 'Applicant',
    Communicator: 'Communicator',
    approve: 'Approve',
    opinion: 'Approval Comments',
    enterMsg: 'Please enter approval comments',
    countersign: 'Countersign',
    record: 'Approval History',
    stopTime: 'Remain {0} day',
    calendar: 'Select Data',
    open: 'open',
    startDate: 'Start Date',
    attachmentDetails: 'Attachment details',
    containsWords: 'Contains Words',
    more:'More',
  },
  launch: {
    Collection: 'Add to Favorites',
    Ownership: 'My Processes',
    All: 'All Processes',
  },
  initiate: {
    initiate: 'My Requests',
    AlreadyDone: 'My Processed',
    recalled: 'Process recalled!',
    successful: 'Recall successfully!',

  },
  processSearch: {
    searchProcess: 'Query Process',
    selectTime: 'Select Time',
    date: 'Date',
    containsWords: 'Contains Words',
    processStatus: 'Process Status',
    applicator: 'Applicant',
    currentApprover: 'Current Approver',
    selectPersonnel: 'Select Personnel',
    expandMore: 'Expand More',
    fold: 'Fold',
    personPlaceholder: 'Person Name/Account Number/Email',
    latelySevenDay: 'Last 7 Days',
    today: 'Today',
    allDay: 'All Time',
    customTime: 'Custom Time',
    searchPlaceholder: 'Folio/Process Name/Process Summary/Process Instance No.',
  },
  myAccount: {
    setting: "Configuration",
    status: "Status",
    personnel: "Personal Information",
    full: "Surname",
    onlyName: "Name",
    name: "First Name",
    gender: "Gender",
    phone: "Telephone",
    email: "Email",
    post: "Position",
    organization: "Organization",
    onJob: "On-the-job",
    offJob: "Off-the-job",
    changeName: "Modify Name",
    changePwd: "Change Password",
    sysLang: "Language",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    currentPasswordPlaceholder: "Please enter password",
    newPasswordPlaceholder: "Enter new password",
    confirmNewPasswordPlaceholder: "Enter new password again",
    enterTheCurrentPassword: "Enter the current password",
    enterTheNewPassword: "Enter a new password",
    enterTheLastName: "Enter the surname",
    enterTheFirstName: "Enter the first name",
    enterTheConfirmNewPassword: "Enter the new password again",
    twoPasswordsNotConsistent: "The two passwords are inconsistent!",
    passwordTips:
      "Only 6-20 characters, including upper and lower case letters, numbers and punctuation (except Spaces)",
    male: "male",
    female: "female",
    uploadAvatarTip:
      "Upload the avatar picture can only be in JPG or PNG format!",
    uploadSizeTip: "Upload profile picture size can not exceed 500 KB!",
    avatarUploadedSuccess: "Head picture uploaded successfully!",
    failedUploadAvatar: "Photo upload failed!",
    modifyPersonalInfoSuccess:
      "Modified your personal information successfully!",
    modifyPersonalInfoFailed: "Failed to modify your personal information!",
    changePasswordSuccess: "Modify password successfully",
    feedback: "Feedback",
    isNotSet:'Is Not Set'
  }
};
